import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-sticky-note',
  templateUrl: './sticky-note.component.html',
  styleUrls: ['./sticky-note.component.scss']
})
export class StickyNoteComponent implements OnInit, OnChanges {
  
  @Input() content: string = '';
  @Input() top: number = 100;
  @Input() left: number = 100;
  @Input() index!: number;
  @Input() isCurrentUser: boolean;
  
  @Output() save = new EventEmitter<{ index: number; content: any }>();
  @Output() delete = new EventEmitter<number>();
  @Output() positionChange = new EventEmitter<{ index: number; top: number; left: number }>();
  text: string | undefined;
  
  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['content'] && changes['content'].currentValue !== undefined) {
      this.text = changes['content'].currentValue;
    }
  }

  onDragEnd(event: any) {
    const pos = event.source.getFreeDragPosition();
    this.top = pos.y;
    this.left = pos.x;
    this.positionChange.emit({ index: this.index, top: pos.y, left: pos.x });
  }

  onDelete() {
    this.delete.emit(this.index);
  }

  onSave() {
    this.save.emit({ index: this.index, content: this.text });
  }

}
